const initializeFaqs = (allFaqs) => {
  [...allFaqs].forEach( faq => {
    const toggleButton = faq.querySelector( '.toggle-all-faqs' );
    const allFaqs = faq.querySelector( '.all-faqs' );

    if (!toggleButton) {
      return;
    }

    toggleButton.addEventListener( 'click', event => {
      event.preventDefault();
      const self = event.currentTarget;

      self.classList.toggle( 'opened' );
      allFaqs.classList.toggle( 'opened' );

      if (!allFaqs.classList.contains( 'opened' )) {
        allFaqs.scrollIntoView( {
          behavior: 'smooth',
          block: 'start',
        } );
      }
    } );
  } );
};

const faqs = (allFaqs) => {
  if (!allFaqs) {
    return;
  }

  initializeFaqs( allFaqs );
};

export default faqs;